import React from "react";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";

import Banner from "../../images/curse/bg_notfall.png";
import Img from "../../images/curse/therapie_aktiv.jpg";

const Curse = () => {
    return (
        <main> 
            <Header image={Banner}/>
            <section className="content-section">
                <Navbar />

                <div className="page-container">
                    <h1> Kurse - Therapie aktiv </h1>
                    <p className="page-text">
                    Unsere <b><i>Therapie aktiv</i></b> Schulungen mit Frau <b>Doz. Katsaros Kastl</b> sind mittlerweile legendär und erfreuen sich eines regen Zustroms.
                    <br /><br />
                    <b>Anmeldung jederzeit.</b> Nehmen Sie an unserer kurzweiligen , humorvollen , exzellenten Fortbildung teil. Anmeldung jederzeit.
                    </p>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <img
                            src={Img}
                            style={{ maxWidth: "300px", height: "auto" }}
                        />
                    </div>
                    <p className="page-text">
                        Es bedeutet eine intensivere und strukturierte Betreuung durch uns – Ihre Therapie Aktiv-Ärztinnen sowie mehr Wissen über Diabetes.
                    </p>

                    <p className="page-text">
                        <b>Finden Sie Gleichgesinnte und gewinnen SIE gemeinsam die Macht über ihren Diabetes!</b>
                    </p>

                    <p className="page-text">Ihr Herzdoktor Team</p>
                    
                </div>

            </section>
            <Footer />
        </main>
    )
}

export default Curse;
